import { isNil } from 'lodash';

export const useSimpleLocalStorage = (key, defaultValue): any[] => {
  let data = defaultValue;
  const save = (value) => {
    window.localStorage.setItem(key, JSON.stringify(value));
  };
  const remove = () => {
    window.localStorage.setItem(key, defaultValue);
  };
  if (typeof window !== 'undefined') {
    try {
      const dataStored = JSON.parse(window.localStorage.getItem(key));
      if (isNil(dataStored) === false) {
        data = dataStored;
      }
      // eslint-disable-next-line no-empty
    } catch (ex) {}
    return [data, save, remove];
  }
  return [data, save, remove];
};
